import { allProductsByUserSourceSelector } from 'core/store/cart/selectors';
import { useAppSelector } from 'core/store/store.utils';

export const useCarouselProductsData = () => {
  const cartProducts = useAppSelector(allProductsByUserSourceSelector);

  return { cartProducts };
};
